/**
 * Simple confirmation dialog réutilisable (promise-based).
 * Usage: <ConfirmDialog open={..} onConfirm={..} onCancel={..} title="..." description="..." />
 */
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmDialog({
  open, title, description, confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler', onConfirm, onCancel, danger = false,
  busy = false,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-4"
         onClick={onCancel}
         data-testid="confirm-dialog">
      <div className="bg-white rounded-xl w-full max-w-md p-5 sm:p-6 space-y-4"
           onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3">
          {danger && (
            <div className="shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-red-600" />
            </div>
          )}
          <div className="flex-1">
            <h3 className="font-bold text-slate-900">{title}</h3>
            {description && (
              <div className="text-sm text-slate-600 mt-1 whitespace-pre-wrap">
                {description}
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onCancel} disabled={busy}
            data-testid="confirm-dialog-cancel">
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={busy}
            className={danger ? 'bg-red-600 hover:bg-red-700 text-white' : 'bg-[#1C49A6] hover:bg-[#173B85]'}
            data-testid="confirm-dialog-confirm"
          >
            {busy ? '…' : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
